import { graphql, HttpResponse } from 'msw'
import {
  CashEquivalentCategory,
  EquitiesSector,
  FixedIncomeCategory,
  type InvestmentAssetAllocation,
} from '../../../models'

/**
 * Mock for the getPortfolioOverviewAssetAllocation query
 * @returns InvestmentAssetAllocation
 */

export const personalPortfolioOverviewAssetAllocationMock: {
  wealthOverview: {
    personalPortfolio: {
      assetAllocation: InvestmentAssetAllocation
    }
  }
} = {
  wealthOverview: {
    personalPortfolio: {
      assetAllocation: {
        __typename: 'InvestmentAssetAllocation',
        preference: {
          equities: 45,
          fixedIncome: 30,
          cashEquivalent: 25,
        },
        equities: {
          __typename: 'InvestmentEquitiesAsset',
          amount: {
            amount: 160,
            currencyCode: 'USD',
          },
          percentage: 20,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          sectors: [
            {
              sector: EquitiesSector.HEALTHCARE,
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Pfizer',
                  symbol: 'PFE',
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.CONSUMER,
              amount: {
                amount: 21,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Apple',
                  symbol: 'AAPL',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.FINANCIAL,
              amount: {
                amount: 22,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'BlackRock',
                  symbol: 'BLK',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.TECHNOLOGY,
              amount: {
                amount: 23,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Netflix',
                  symbol: 'NFLX',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.INDUSTRY,
              amount: {
                amount: 24,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Caterpillar',
                  symbol: 'CAT',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
                {
                  name: 'Raytheon',
                  symbol: 'RTX',
                  amount: {
                    amount: 85.45,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.ENERGY,
              amount: {
                amount: 25,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'FPL',
                  symbol: 'FPL',
                  costBasis: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  amount: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.REAL_ESTATE,
              amount: {
                amount: 26,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'Airbnb',
                  symbol: 'ABNB',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              sector: EquitiesSector.MEDIA,
              amount: {
                amount: 27,
                currencyCode: 'USD',
              },
              percentage: 12.5,
              holdings: [
                {
                  name: 'CBS',
                  symbol: 'CBS',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        fixedIncome: {
          __typename: 'InvestmentFixedIncomeAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 25,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          categories: [
            {
              category: FixedIncomeCategory.GOVERNMENT_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'US Treasury',
                  symbol: 'UST',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.MUNICIPAL_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'California',
                  symbol: 'CAM',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 5,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.CORPORATE_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Apple',
                  symbol: 'APL',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.HIGH_YIELD_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Junk',
                  symbol: 'JNK',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
            {
              category: FixedIncomeCategory.INTERNATIONAL_BONDS,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Euro',
                  symbol: 'EUR',
                  amount: {
                    amount: 20,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        cashEquivalent: {
          __typename: 'InvestmentCashEquivalentAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 40,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
          categories: [
            {
              category: CashEquivalentCategory.CORPORATE,
              percentage: 20,
              amount: {
                amount: 100,
                currencyCode: 'USD',
              },
              holdings: [
                {
                  name: 'Short-term',
                  symbol: 'USD',
                  amount: {
                    amount: 100,
                    currencyCode: 'USD',
                  },
                  costBasis: {
                    amount: 10,
                    currencyCode: 'USD',
                  },
                  quantity: 0.0302,
                },
              ],
            },
          ],
        },
        other: {
          __typename: 'InvestmentOtherAsset',
          amount: {
            amount: 100,
            currencyCode: 'USD',
          },
          percentage: 15,
          holdings: [
            {
              name: 'Pfizer',
              symbol: 'PFE',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Netflix',
              symbol: 'NFLX',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
            {
              name: 'Airbnb',
              symbol: 'ABNB',
              amount: {
                amount: 20,
                currencyCode: 'USD',
              },
              quantity: 0.0302,
            },
          ],
        },
      },
    },
  },
}

export const mockGetPortfolioOverviewAssetAllocationHandler = graphql.query('portfolioOverviewAssetAllocation', () => {
  return HttpResponse.json({
    data: {
      wealthOverview: {
        personalPortfolio: {
          assetAllocation:
            personalPortfolioOverviewAssetAllocationMock.wealthOverview.personalPortfolio.assetAllocation,
        },
      },
    },
  })
})

export const mockPortfolioOverviewAssetAllocation = [mockGetPortfolioOverviewAssetAllocationHandler]
